// Generic table. columns: [{ key, header, render?(row) }]. Handles loading/empty/error.
export default function DataTable({ columns, rows, isLoading, error, emptyText = 'No records found.', actions }) {
  if (isLoading) return <div className="state state--loading">Loading…</div>;
  if (error) return <div className="state state--error" role="alert">{error.message || 'Failed to load.'}</div>;
  if (!rows || rows.length === 0) return <div className="state state--empty">{emptyText}</div>;

  return (
    <table className="table">
      <thead>
        <tr>
          {columns.map((c) => <th key={c.key}>{c.header}</th>)}
          {actions && <th className="table__actions-col">Actions</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            {columns.map((c) => (
              <td key={c.key}>{c.render ? c.render(row) : row[c.key]}</td>
            ))}
            {actions && <td className="table__actions">{actions(row)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
